module.exports = __webpack_public_path__ + "static/img/room_cg_qr.23865a51.png";